module.exports = __webpack_public_path__ + "static/sca-logo-3a037152aeaf00545fea32c7c86e8dac.jpg";